<template>
  <ThemeDefaultLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :categories="asyncCategory?.categoryButtonItems"
    :event-name="eventName"
    :category-event-name="categoryEventName"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <div v-if="products && products.length > 0">
      <div
        class="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-4 sm:tw-gap-x-5 tw-gap-y-8 sm:tw-gap-y-10"
      >
        <div v-for="(item, index) in products" :key="index">
          <ThemeDefaultCardProduct
            title-tag="h2"
            :image="item.imageCover"
            :title="item.title"
            :options="item.options"
            :price="item.price"
            :show-option-list="false"
            :price-of-discounted="item.priceOfDiscounted"
            :max-price-option="item.maxPriceOption"
            :min-price-option="item.minPriceOption"
            :min-price-of-discounted-option="item.minPriceOfDiscountedOption"
            :max-price-of-discounted-option="item.maxPriceOfDiscountedOption"
            :path="getPath({ componentName: 'Product', slug: item.slug })"
            :recommended="item.recommended"
            :category="{
              _id: item.productCategory._id,
              title: item.productCategory?.title || '',
              slug: item.productCategory?.slug || '',
              path: getPath({
                componentName: 'Product',
                categorySlug: item.productCategory?.slug || '',
              }),
            }"
            @click="eventProduct(item.title)"
          />
        </div>
      </div>
      <Pagination v-model="page" :per-page="perPage" :total="total" rounded />
    </div>
    <LandingNoData v-else />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  breadcrumbs,
  asyncCategory,
  products,
  page,
  perPage,
  total,
  getPath,
  categoryEventName,
  eventName,
  eventProduct,
} = await useProductPage();
</script>

<style>
.q-page-container {
  padding-bottom: 0px !important;
}
</style>
